import { z } from 'zod';
import datos from '../catalogo.json' with { type: 'json' };
import { catalogoFotos } from './fotos.ts';

const id = z.string().regex(/^[a-z0-9_]+$/);

const geometria = z.discriminatedUnion('tipo', [
  z.object({
    tipo: z.literal('rect'),
    x: z.number(),
    y: z.number(),
    ancho: z.number(),
    alto: z.number(),
    radio: z.number(),
  }),
  z.object({ tipo: z.literal('path'), d: z.string(), centro: z.tuple([z.number(), z.number()]) }),
]);

export const estadoZona = z.enum(['sin', 'ray', 'gol', 'que', 'na']);
export const estadoAccesorio = z.enum(['presente', 'ausente', 'sin_revisar']);
export const motivoIngreso = z.enum(['siniestro', 'particular', 'garantia']);
/**
 * `siniestro`: insurance damage survey for the adjuster and the quote, done
 * before the car is admitted (no accessories, no fuel, optional signature).
 * `recepcion` is shown as "Ingreso" in every UI; the id stays for compatibility.
 */
export const tipoInspeccion = z.enum(['siniestro', 'recepcion', 'reingreso', 'entrega']);

export const catalogoSchema = z.object({
  version: z.number().int(),
  zonas: z.array(
    z.object({ id, nombre: z.string(), extra: z.boolean(), geometria: geometria.nullable() }),
  ),
  viewBox: z.tuple([z.number(), z.number(), z.number(), z.number()]),
  estadosZona: z.array(
    z.object({
      id: estadoZona,
      simbolo: z.string(),
      nombre: z.string(),
      severidad: z.number().int().nullable(),
      requiereFoto: z.boolean(),
    }),
  ),
  accesorios: z.array(z.object({ id, nombre: z.string() })),
  estadosAccesorio: z.array(z.object({ id: estadoAccesorio, nombre: z.string() })),
  nivelesCombustible: z.array(z.object({ indice: z.number().int(), etiqueta: z.string() })),
  fases: z.array(
    z.object({
      id,
      nombre: z.string(),
      cupo: z.number().int().positive(),
      duracionDias: z.number().int().nonnegative(),
      umbralAtrasoDias: z.number().int().positive(),
    }),
  ),
  motivosIngreso: z.array(
    z.object({ id: motivoIngreso, nombre: z.string(), pideSiniestro: z.boolean() }),
  ),
  tiposInspeccion: z.array(tipoInspeccion),
  avisosLegales: z.array(z.string().min(1)),
  /** Evidence master compression profiles (shared/src/fotos.ts). */
  fotos: catalogoFotos,
});

export type Catalogo = z.infer<typeof catalogoSchema>;
export type EstadoZona = z.infer<typeof estadoZona>;
export type TipoInspeccion = z.infer<typeof tipoInspeccion>;

export const catalogo: Catalogo = catalogoSchema.parse(datos);
